export default "__VITE_ASSET__3m1uKfto__"